module.exports = __webpack_public_path__ + "static/media/carrier-smartcomfort.444bdd79.jpg";